function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.014 49.985c-13.76.1-25.26-11.29-25.01-25.46.23-13.43 11.32-24.81 25.55-24.52 13.45.26 24.47 11.29 24.45 24.96-.03 13.9-11.13 25.02-24.99 25.02zm2.4-24.83c1.21 0 2.31-.01 3.41.01.45.01.68-.13.72-.63.1-1.32.26-2.63.37-3.95.07-.82.03-.85-.81-.85-1.06-.01-2.12-.01-3.18.02-.44.01-.6-.14-.58-.56.03-.77.01-1.54.05-2.31.05-1 .51-1.48 1.52-1.55.81-.06 1.63-.05 2.45-.03.5.01.7-.16.68-.7-.03-1.26-.04-2.52 0-3.77.02-.61-.19-.83-.8-.81-1.59.06-3.17.07-4.76.11-2.9.09-5.09 2.08-5.37 4.99-.13 1.36-.1 2.73-.11 4.09 0 .46-.14.63-.61.6-.62-.04-1.24 0-1.85-.02-.45-.02-.63.15-.62.62.02 1.37.02 2.74 0 4.1-.01.48.2.63.63.62.53-.01 1.06.01 1.59-.01.84-.03.84-.03.84.81v13.23c0 .92.02.95.91.95h4.57c.91 0 .94-.03.94-.93 0-3.62-.01-7.24-.01-10.85.02-1.02.02-2.05.02-3.18z",
  fill: "#2A5297"
});

var SvgSourceFacebook = function SvgSourceFacebook(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_facebook.dd39de64.svg";
export { ForwardRef as ReactComponent };